import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { ISiteCEPPStatusResult } from '../types/IActivityLog';

export class ActivityLogGetSiteStatusRequest extends Request<{}, ISiteCEPPStatusResult> {
    constructor() {
        super('getSiteCEPPStatus', {});
    }
}
